import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import TextInput from 'components/Common/Form/Input/TextInput'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'
import { formToObject } from 'lib/formToObject'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { Form } from '../common'
import { resetUserPassword } from 'actions/AuthActions'
import Group from 'components/utils/Group'

const Footer = styled.div`
  margin-top: ${rem(40)};
`
interface ResetPasswordForm {
  password: string;
}

interface Props {
  error?: any;
  processing?: boolean;
  open: boolean;
  token: string;
}

function ResetPassword(props: Props) {
  const {
    error,
    processing,
    open,
    token,
  } = props

  const firstInput = useRef<HTMLInputElement>(null)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (open) {
      firstInput.current?.focus()
    }
  }, [open])

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const { password } = formToObject<ResetPasswordForm>(e.currentTarget)

    dispatch(resetUserPassword(token, password))
  }

  return (
    <Form onSubmit={onSubmit} name="forgotPasswordForm">
      <Group direction="vertical" gap={20}>
        {error?.message && <MessageBanner kind="critical" description={error.message} />}
        <Group direction="vertical" gap={4}>
          <Heading variant="heading3">
            Update your password
          </Heading>
          <BodyText variant="large">
            Enter a new password
          </BodyText>
        </Group>
      </Group>
      <TextInput
        id="password"
        type="password"
        name="password"
        label="New password"
        placeholder="New password"
        requiredErrorMessage="Password is required"
        inputRef={firstInput}
        minLength={8}
        required
      />
      <BodyText colour="neutral-two" variant="small">Minimum 8 characters</BodyText>

      <Group direction="horizontal" horizontalAlign="end">
        <TextButton
          kind="primary"
          type="submit"
          disabled={processing}
        >
          Change password
        </TextButton>
      </Group>
      <Footer />
    </Form>
  )
}

function mapStateToProps(state: App.State) {
  return {
    processing: state.auth.processing,
    error: state.auth.error,
  }
}

export default connect(mapStateToProps)(ResetPassword)
